import { Plans } from '../translations-types';

const translations: Plans = {
  title: 'Treatment courses',
  description:
    'Define a treatment course (free name) with a linked questionnaire. Add customers, ask whether they want it, and on "yes" they automatically receive the questionnaire.',
  newPlan: 'New treatment course',
  editPlan: 'Edit treatment course',
  renew: 'Renew',
  renewPlan: 'Renew treatment course',
  deletePlan: 'Delete treatment course',
  deleteConfirm: 'Are you sure? The treatment course will be deleted.',
  deleteBlocked: 'You can only delete a course without active members.',
  yearTooFar: 'The year can be at most one year in the future.',
  renewMaxYear: 'You can renew at most one year ahead.',
  statusColumn: 'Status',
  statusAskedSent: 'Question sent',
  statusAgreed: 'Agreed',
  statusNotAgreed: 'Declined',
  qSentLong: 'Questionnaire sent',
  qCompletedLong: 'Questionnaire completed',
  name: 'Name',
  year: 'Year',
  planDescription: 'Description',
  previewOfferEmail: 'Preview email',
  previewOfferEmailTitle: 'Approval email preview',
  previewGreeting: 'Dear [client name],',
  previewIntro:
    'We would love to know whether you want to continue with {plan} next year. You can let us know with a single click below.',
  previewAnswerLabel: 'Reply here:',
  previewAnswerLink: 'Reply yes or no',
  previewYesInfo: 'If you choose yes, we will send you the related questionnaire by email.',
  previewClosing: 'Kind regards,',
  previewPlanFallback: 'this plan',
  questionnaire: 'Questionnaire',
  status: 'Status',
  active: 'Active',
  archived: 'Archived',
  selectPlan: 'Choose a treatment course',
  noPlans: 'No treatment courses yet',
  saved: 'Saved',
  deleted: 'Deleted',
  addCustomers: 'Add customers',
  addManual: 'Manual',
  fromPlan: 'Previous treatment course',
  fromPlanHint: 'Copy the members (who said yes) of another treatment course.',
  fromField: 'Customer label',
  fromFieldHint: 'Filter customers by a customer label.',
  selectField: 'Choose a customer label',
  fieldValue: 'Value (empty = any filled value)',
  selectCustomers: 'Search and select customers',
  add: 'Add',
  found: 'Found',
  notFound: 'Not found',
  overview: 'Overview',
  customer: 'Customer',
  askStatus: 'Customer approval',
  questionnaireStatus: 'Questionnaire',
  statusAdded: 'Added',
  statusPending: 'Asked',
  statusAccepted: 'Yes',
  statusDeclined: 'No',
  statusNoResponse: 'No response',
  qNotSent: '—',
  qSent: 'Sent',
  qCompleted: 'Completed',
  sendAsk: 'Send question',
  resendAsk: 'Resend',
  sendAskAll: 'Send to everyone',
  askSent: 'Question sent',
  askSentAll: '{count} questions sent',
  setAccepted: 'Set yes',
  setDeclined: 'Set no',
  noOffers: 'No customers added yet',
  members: 'members',
  searchCustomer: 'Search customer',
  searchPlans: 'Search treatment course',
  allStatuses: 'All',
  planKind: 'Type',
  renewableOption: 'Renewable',
  oneTimeOption: 'One-time',
  durationType: 'Duration',
  durationCalendarYear: 'Calendar year',
  durationCustomerStart: 'From customer start date',
  durationMonthsOption: 'Number of months',
  durationTreatments: 'Number of treatments',
  durationMonths: 'Months',
  treatmentCountLabel: 'Number of treatments',
  plannedTreatmentsHint: 'Number of planned treatments in this period (optional, adjustable per member)',
  startDate: 'Start date',
  endDate: 'End date',
  treatmentsDoneLabel: 'Appointments',
  treatmentPlan: 'Treatment plan',
  treatmentPlanNote: 'Note',
  lastCompletedColumn: 'Last completed',
  overviewButton: 'Overview',
  overviewAnswersTitle: 'Answers',
  overviewAppointmentsTitle: 'Appointments this period',
  planningProposalTitle: 'Schedule proposal',
  generateProposal: 'Generate schedule proposal',
  regenerateProposal: 'Regenerate',
  proposalGeneratedAt: 'Generated on',
  proposalGenerating: 'Generating…',
  proposalNotesLabel: 'Notes for the schedule',
  proposalNotesPlaceholder: 'These notes take priority over the default instruction.',
  carryOver: 'Copy participants from',
  carryOverHint:
    'The "Yes" members of the selected course are added as "Added" to this new course; renew each person via "Set yes" or by sending the renewal question.',
  expiringSoon: 'Expiring soon',
  expired: 'Expired',
  goalReached: 'Goal reached',
  expiryFilter: 'Expiry',
  expiringCountLabel: 'expiring soon',
  linkAppointments: 'Link appointments',
  linkAppointmentsTitle: 'Link appointments to course',
  appointmentDate: 'Date',
  appointmentService: 'Treatment',
  appointmentEmployee: 'Employee',
  plannedHint: 'Planned — counts once it has taken place',
  syncedOnlyHint: 'Only synced appointments are shown.',
  noAppointments: 'No appointments found',
  manualApproval: 'Manual approval',
  manageMembership: 'Membership',
  membershipNotRenewing: 'Not renewing',
  membershipStopped: 'Stopped',
  membershipSwitched: 'Switched',
  membershipWillRenew: 'Wants to renew',
  membershipRenewed: 'Renewed',
  actionStop: 'Stop early',
  actionSwitchNow: 'Switch (now)',
  actionSwitchEnd: 'Switch (end of term)',
  reactivate: 'Reactivate',
  switchTargetPlan: 'Target course',
  exitDate: 'Date',
  exitReason: 'Reason',
  switchTimingImmediate: 'mid-term',
  switchTimingEnd: 'end of term',
  endedCountLabel: 'stopped/switched',
};

export default translations;
